import React from 'react';
import { Modal, Field } from './ui';

// Mobile (APK) add/edit form modal for the field-driven CRUD folders: full-screen,
// one field per row. Reads the useCrudList `vm`.
export default function CrudFormModalMobile({ vm, title }) {
  const { editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!vm.open) return null;
  return (
    <Modal
      fullScreen
      title={`${editing ? 'Edit' : 'Add'} ${title}`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      <div className="form-grid">
        {fields.map(f => (
          <div key={f.key} style={{ gridColumn: '1 / -1' }}>
            <Field
              label={f.label} type={f.type || 'text'} value={values[f.key]}
              options={f.options} required={f.required}
              onChange={(v) => setField(f, v)}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
}
